export default {
    state: {
        list: null,

        count: 0,

        filters: {
            unknown: false,
            local: [],
        },

        advertisers: null,
    },

    mutations: {
        CONNECTIONS_SET_LIST(state, list) {
            state.list = list;
        },

        CONNECTIONS_SET_COUNT(state, count) {
            state.count = count;
        },

        CONNECTIONS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        CONNECTIONS_RESET_FILTERS(state) {
            state.filters = {};
        },
    },
};
